import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useApiMutation from '../useApiMutation';
import useMessage from '../../useMessage';

const useCreateVideo = () => {
  const [headlinerVideoUrl, setHeadlinerVideoUrl] = useState(null);
  const { message } = useMessage();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId, episodeId }) => `/shows/${showId}/episodes/${episodeId}/promovideos`,
    method: 'POST',
    onSuccess: (result) => {
      if (result?.redirectUrl && result?.customTraceId) {
        setHeadlinerVideoUrl(result.redirectUrl);
      } else {
        message.danger({
          content: (
            <FormattedMessage defaultMessage="Something went wrong while connecting to Headliner. You can't create a new video at the moment." />
          ),
        });
      }
    },
    onError: () => {
      message.danger({
        content: (
          <FormattedMessage defaultMessage="There was an error while creating your video." />
        ),
      });
    },
  });

  return {
    headlinerVideoUrl,
    createVideo: mutation.mutate,
    isCreateVideoLoading: mutation.isLoading,
    isCreateVideoError: mutation.isError,
    isCreateVideoSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useCreateVideo;
